const TTL_MS = 30 * 60 * 1000; // 30 minutos

// La caché guarda sólo listas completas (arreglos). Las claves vigentes son `cat_v2_<nombre>`:
// las antiguas `cat_<nombre>` pueden contener una página parcial o un objeto paginado y quedan
// ignoradas hasta expirar. Un valor que no sea arreglo se trata como fallo de caché.

export function getCached(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const { data, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    return Array.isArray(data) ? data : null;
  } catch {
    return null;
  }
}

export function setCached(key, data) {
  try {
    sessionStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch {
    // sessionStorage lleno o bloqueado — continuar sin caché
  }
}
